module.exports = __webpack_public_path__ + "img/17-1.76682005.png";